<template>
	<Tag :color="color">{{ level }}</Tag>
</template>

<script lang="ts">
import { computed } from 'vue';
import { Tag } from 'ant-design-vue';

const TAG_COLORS: Record<string, string> = {
	DEBUG: 'green',
	INFO: 'blue',
	WARNING: 'orange',
	ERROR: 'red',
};

export default {
	components: {
		Tag,
	},
	props: {
		level: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const color = computed(() => TAG_COLORS[props.level.toUpperCase()]);
		return {
			color,
		};
	},
};
</script>
